import { Separator } from "@/components/ui/separator";
import { DadosResumoGiro } from "@/dtos/Request/FinalizarCompraSorteioGiroDto";
import { labelPlural } from "@/utils/copyTituloBilhete";

interface FinalizarCompraGiroResumoProps {
    dadosResumo: DadosResumoGiro;
}

export function FinalizarCompraGiroResumo({ dadosResumo }: FinalizarCompraGiroResumoProps) {
    return (
        <div className="flex flex-col bg-slate-100 rounded-lg px-10 py-4 w-full">
            <h1 className="text-primary-foreground font-semibold text-xl my-2">Resumo da Compra — Giro</h1>

            <div className="flex justify-between">
                <span>Quantidade de {labelPlural()}</span>
                <span className="font-medium">{dadosResumo.quantidade}</span>
            </div>
            <div className="flex justify-between">
                <span>Data Sorteio</span>
                <span className="font-medium">{dadosResumo.dataSorteio}</span>
            </div>
            <div className="flex justify-between">
                <span>Edição</span>
                <span className="font-medium">{dadosResumo.edicao}</span>
            </div>

            <div className="mt-8">
                <Separator />
                <div className="flex justify-between mt-2">
                    <span>Valor Total</span>
                    <span className="font-bold">
                        {dadosResumo.valorTotal.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
}
